import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {DocumentActions, FEATURE} from '../../redux/actions/documents';
import {CommandActions as DocumentCommandActions} from '../../redux/actions/document';
import {CommandActions as DocumentsCommandActions, DocumentActions as DocumentDocumentsActions} from '../../redux/actions/documents';
import {CommandActions as ModalCommandActions} from '../../redux/actions/modal';
import {CommandActions as FiltersCommandActions} from '../../redux/actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom'
import CommandBar from './command_bar/index'
import Notification from '../notification/index';
import { getNotification } from '../../redux/selectors/notification';
import { getFilterPanelOpened } from '../../redux/reducers/ui';
import { getLoader } from '../../redux/selectors/loader';
import { IColumn, MessageBarType, ProgressIndicator, Spinner, SpinnerSize, Selection } from '@fluentui/react';
import { getClassNames } from './index.classNames';
import { getColumns } from '../documents/columns';
import SelectedFilters from '../filtersPanel/filters/selectedFilters';
import _ from 'lodash';
import { getOrderColumn, getSelectedItemsIds, getTotal } from '../../redux/reducers/documents';
import { Document, FileForm } from '../../models/document';
import DocumentModal from '../modals/document'
import DocumentsGrid from '../documents/index'
import { getSelectedProjectUserActions, getSelectedProjectUserRole } from '../../redux/selectors/auth';
import { getFilters, getShowCallout } from '../../redux/reducers/filters';
import { Filters } from '../../models/filters';
import { getGenericModal, getNotificationWidth } from '../../redux/selectors/ui';
import CalloutFilters from '../filtersPanel/callout/index';
import { MainCompGenerator as GenericModalGenerator, Actions as GenericModalActions } from '@pwbapps/genericdialog'
import UploadFiles from '../documents/functionalities/uploadReplaceFile';
import ChangeStatus from '../documents/functionalities/changeStatus';
import EditDocument from '../documents/functionalities/editDocument';
import { InternalRoleActionsType, ExternalRoleActionsType, getTheme } from '../../utils/costants';
import { getHistoryName } from '../../utils/functions';
import { Status } from '../../models/status';
import { getDocument } from '../../redux/reducers/document';
import { getContextualDocument, getContextualDocuments } from '../../redux/selectors/documents';
import DownloadFiles from '../documents/functionalities/downloadFiles';
import DownloadComments from '../documents/functionalities/downloadComments';
import DownloadExcelReport from '../documents/functionalities/downloadExcelReport';
import { withTranslation, WithTranslation  } from 'react-i18next';
import { getEmail } from '@pwbapps/reduxcore/dist/redux/reducers/auth';
import { getDarkModeEnabled } from '../../redux/reducers/project';
let GenericModal = GenericModalGenerator();

export interface PendingProps extends RouteComponentProps, WithTranslation {
    loading: boolean,
    loadingContent: boolean,
    loadingScroll: boolean,
    selectedItemIds: string[],
    documents: Document[]
    filterPanelOpened: boolean, 
    showNotification: boolean, 
    type: MessageBarType, 
    message: string,
    userProjectActions: InternalRoleActionsType[] | ExternalRoleActionsType[],
    filters: Filters,
    showCallout: boolean,
    orderColumn: {name: string, direction: string },
    changeStatusForm?: {
        newStatus: Status,
        fileForm?: FileForm,
        files?: any[]
    },
    uploadFileForm: {files: any[], fileForm: FileForm},
    document?: Document,
    notificationWidth: string,
    total: number,
    email?: string,
    darkModeEnabled: boolean
    setSelectedItemsIds: typeof DocumentActions.setSelectedItemsIds,
    getDocumentAndOpenModal: typeof DocumentCommandActions.getDocumentAndOpenModal,
    showOrHideCallout: typeof FiltersCommandActions.showOrHideCallout,
    closeGenericModal: typeof ModalCommandActions.closeModal,
    downloadOrShowFile: typeof DocumentsCommandActions.downloadOrShowFile,
    changeStatus: typeof DocumentsCommandActions.changeStatus,
    fetchDocuments: typeof DocumentsCommandActions.fetchDocuments,
    setSortColumn: typeof DocumentDocumentsActions.setSortColumn,
    setData: typeof DocumentDocumentsActions.setData,
    uploadDocuments: typeof DocumentsCommandActions.uploadDocuments,
    downloadFiles: typeof DocumentsCommandActions.downloadFiles,
    downloadComments: typeof DocumentsCommandActions.downloadComments,
    downloadExcelReport: typeof DocumentsCommandActions.downloadExcelReport
}
class Pending extends React.Component<PendingProps & RouteComponentProps> {
    constructor(props: PendingProps) {
        super(props);   
    }

   

    getFilters = (): Filters => {
        const { filters } = this.props;
        return filters;
    }

    getFilterPanel = (): boolean => {
        const { filterPanelOpened } = this.props;
        return filterPanelOpened;
    }

    onColumnClick = (ev: React.MouseEvent<HTMLElement>, column: IColumn): void => {
        const { fetchDocuments, setSortColumn } = this.props; 
        setSortColumn({colName: column.fieldName as string, direction: (column.isSortedDescending) ? 'asc' : 'desc', feature: FEATURE});
        this.selection.setAllSelected(false);    
        fetchDocuments({});
    };

    selection = new Selection({		
		onSelectionChanged: () => {
            let rows = this.selection.getSelection() as any;
            const {setSelectedItemsIds} = this.props;
            let ids = (rows) ? _.map(rows, (r: Document) => {return r.id as number}) : [];
            setSelectedItemsIds({ids: _.map(ids, id => id.toString()), feature: FEATURE}) 
		}
    });

    render(){
        const {loading, loadingContent, showNotification, type, message, filterPanelOpened, orderColumn, loadingScroll, userProjectActions, history, changeStatusForm, total, documents, notificationWidth, t, email, darkModeEnabled, uploadFileForm,
               getDocumentAndOpenModal, showOrHideCallout, downloadFiles, downloadOrShowFile, changeStatus, downloadComments, closeGenericModal, uploadDocuments, downloadExcelReport} = this.props;
        const styles = getClassNames(filterPanelOpened);
        const historyName = getHistoryName(history);
        const showWarningMessage = !((documents.length === 0 && total < 100) || (documents.length > 0 && documents.length < 100));
        const canRead = _.find(userProjectActions, a => a === 'ReadPending') ? true : false;
        const canDeleteFiles = _.find(userProjectActions, a => a === 'UploadAttachmentPending' || a === 'UploadCommentFilePending') ? true : false;
        const canUploadAttachments = _.find(userProjectActions, a => a === 'UploadAttachmentDashboard') ? true : false;
        const canUploadFileComments = _.find(userProjectActions, a => a === 'UploadCommentFileDashboard') ? true : false;
        const columns = getColumns(email as string, t, canRead, canDeleteFiles, this.selection, this.getFilterPanel, getDocumentAndOpenModal, this.getFilters, showOrHideCallout, downloadOrShowFile, this.onColumnClick, orderColumn, historyName, undefined, undefined, undefined, _.some(userProjectActions, a => a === 'FilterDocumentsByPartnerId'), getTheme(darkModeEnabled));
        return (
            <>
                <CommandBar userProjectActions={userProjectActions} loading={loading} loadingContent={loadingContent} loadingScroll={loadingScroll}/>
                <div style={{position: 'absolute', width: notificationWidth, top: 99, zIndex: 10}}>
                    {!loading && !loadingContent && <Notification name={'pending'} show={showNotification} type={type} message={message}/>}
                </div>
                <SelectedFilters/>
                <ProgressIndicator styles={{root: {height: 10}}} progressHidden={ !loadingContent || loading }/> 
                {loading && <Spinner size={SpinnerSize.large} style={{marginTop: 50}}></Spinner>}
                {!loading &&
                    <div className={styles.resultContainer}>
                        <DocumentsGrid selection={this.selection} columns={columns} loadingScroll={loadingScroll}/>
                        <DocumentModal userProjectActions={userProjectActions}/>
                    </div>
                }
                <CalloutFilters/>
                <GenericModal 
                    id={'changeStatus'}
                    title={t('Change Status')}
                    message={''}                 
                    onClose={() => {}}
                    btnCloseText={t('Cancel')}
                    onConfirm={() => {changeStatus({documents})}}
                    btnConfirmText={t('Save')}
                    customComponent={<ChangeStatus loadingContent={loadingContent}/>}
                    width={640}
                    disableConfirm={!changeStatusForm || (changeStatusForm.newStatus && (changeStatusForm.newStatus.name === 'approved-comments' || changeStatusForm.newStatus.name === 'rejected') && (!changeStatusForm.newStatus.comment && (!changeStatusForm.files || changeStatusForm.files.length === 0)))}
                />
                <GenericModal 
                    id={'uploadDocuments'}
                    title={(uploadFileForm && uploadFileForm.fileForm && uploadFileForm.fileForm.isParent) ? t('Replace file') : t('Upload files')}
                    message={''}                 
                    onClose={() => {closeGenericModal({id: 'uploadDocuments'})}}
                    btnCloseText={t('Cancel')}
                    btnConfirmText={t('Save')}
                    onConfirm={( )=> {uploadDocuments({})}}
                    disableConfirm={loadingContent || !uploadFileForm || !uploadFileForm.files || uploadFileForm.files.length === 0}
                    customComponent={<UploadFiles loadingContent={loadingContent} canUploadAttachments={canUploadAttachments} canUploadFileComments={canUploadFileComments}/>}
                    disableAutoModalClose 
                    disableClose={loadingContent}  
                    width={640}         
                />
                <GenericModal 
                    id={'fileName'}
                    title={t('Download files')}
                    message={(!showWarningMessage) ? '' : t('Recommended maximum download: 100 documents. Click OK to proceed. Note: Exceeding this may increase download time.')}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadFiles()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadFiles/>}
                    disableConfirm={loadingContent}     
                />
                <GenericModal 
                    id={'comments'}
                    title={t('Download comments')}
                    message={''}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadComments()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadComments/>}
                    disableConfirm={loadingContent}     
                />
                <GenericModal 
                    id={'excelReport'}
                    title={t('Download Excel report')}
                    message={''}                 
                    onClose={() => {}}
                    onConfirm={() => {downloadExcelReport()}}
                    btnConfirmText={t('Download')}
                    btnCloseText={t('Cancel')}   
                    customComponent={<DownloadExcelReport/>}
                    disableConfirm={loadingContent}
                    width={540}    
                />
            </>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    loading: (state) => getLoader('pending')(state).loading,
    loadingContent: (state) => getLoader('pending')(state).loadingContent,
    loadingScroll: (state) => getLoader('pending')(state).loadingScroll,
    showNotification: (state) => getNotification('pending')(state).show,
    type: (state) => getNotification('pending')(state).type,
    message: (state) => getNotification('pending')(state).message,
    filterPanelOpened: getFilterPanelOpened,
    userProjectActions: getSelectedProjectUserActions,
    filters: getFilters,
    changeStatusForm: (state) => (getGenericModal('changeStatus')(state)) ? (getGenericModal('changeStatus')(state) as any).contextItem : undefined,
    uploadFileForm: (state) => (getGenericModal('uploadDocuments')(state)) ? (getGenericModal('uploadDocuments')(state) as any).contextItem : undefined,
    orderColumn: getOrderColumn,
    documents : getContextualDocuments,
    notificationWidth: getNotificationWidth,
    total: getTotal,
    email: getEmail,
    darkModeEnabled: getDarkModeEnabled
});

function matchDispatchToProps(dispatch: any){
    return bindActionCreators({
        setSelectedItemsIds: DocumentActions.setSelectedItemsIds,
        getDocumentAndOpenModal: DocumentCommandActions.getDocumentAndOpenModal,
        showOrHideCallout: FiltersCommandActions.showOrHideCallout,
        closeGenericModal: ModalCommandActions.closeModal,
        downloadOrShowFile: DocumentsCommandActions.downloadOrShowFile,
        changeStatus: DocumentsCommandActions.changeStatus,
        fetchDocuments: DocumentsCommandActions.fetchDocuments,
        setSortColumn: DocumentDocumentsActions.setSortColumn,
        setData: DocumentDocumentsActions.setData,
        uploadDocuments: DocumentsCommandActions.uploadDocuments,
        downloadFiles: DocumentsCommandActions.downloadFiles,
        downloadComments: DocumentsCommandActions.downloadComments,
        downloadExcelReport: DocumentsCommandActions.downloadExcelReport
    }, dispatch);
}


export default connect(mapStateToProps, matchDispatchToProps)(withTranslation()(withRouter(Pending)));